import React, { Component } from 'react';
import PropTypes from 'prop-types';

class File extends Component {
  static defaultProps = {
    maxSize: 10, //in MB
    required: true,
    type: 'image',
  };

  state = {
    file: null,
    fileName: null,
  };

  updateFile = e => {
    e.persist();

    const { onFieldChange } = this.props;
    const reader = new FileReader();
    const input = e.target;
    const file = input.files[0];

    this.setState({ fileName: null });

    if (file) {
      const isValid = this.validatefile(input, file);

      this.setState({ fileName: file.name });

      if (isValid) {
        reader.onloadend = reader => {
          const result = reader.target.result;

          this.setState({ file: result });

          onFieldChange(input, result, true);
        };

        reader.readAsDataURL(file);
      } else {
        onFieldChange(input, null, true);
      }
    }
  };

  validatefile = (input, file) => {
    const { maxSize } = this.props;
    const errorMessage = 'O ficheiro excede o tamanho máximo.';

    if (file.size > maxSize * 1024 * 1024) {
      input.setCustomValidity(errorMessage);

      return false;
    }

    input.setCustomValidity('');

    return true;
  };

  render() {
    const { question, maxSize, name, required, type } = this.props;
    const className = 'field field--file';
    const { file, fileName } = this.state;

    return (
      <div className={className}>
        <legend className="field__label">{question}</legend>
        <div className="field__wrap">
          <input id={name} name={name} type="file" accept={type + '/*'} onChange={this.updateFile} required={required} />
          <span className="field__file">
            <span>{fileName || 'Carregue um ficheiro'}</span>
          </span>
          <label htmlFor={name} className="field__button">
            Carregar
          </label>
        </div>
        <span className="field__helper">Máximo {maxSize}MB</span>
        {file && (
          <div className="field__wrap">
            {type === 'video' ? (
              <video src={file} className="field__preview" controls />
            ) : (
              <img src={file} className="field__preview" alt="" />
            )}
          </div>
        )}
      </div>
    );
  }
}

File.propTypes = {
  question: PropTypes.string.isRequired,
  maxSize: PropTypes.number,
  name: PropTypes.string.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  type: PropTypes.oneOf(['image', 'video']),
};

export default File;
